import type { ServiceMode } from "../types";

export const SERVICE_MODES: ServiceMode[] = [
  "full_content",
  "creative_direction",
];

// Platforms the agency usually manages for a client. Values are stored, labels shown.
export const MANAGED_PLATFORMS = [
  { id: "instagram", name: "Instagram" },
  { id: "facebook", name: "Facebook" },
  { id: "tiktok", name: "TikTok" },
  { id: "youtube", name: "YouTube" },
  { id: "linkedin", name: "LinkedIn" },
  { id: "meta-ads", name: "Meta Ads (Business Manager)" },
  { id: "google-ads", name: "Google Ads" },
  { id: "google-analytics", name: "Google Analytics" },
  { id: "google-business", name: "Perfil de Google Business" },
  { id: "website", name: "Sitio web / hosting" },
  { id: "other", name: "Otro" },
];

export const getPlatformLabel = (platformId: string): string =>
  MANAGED_PLATFORMS.find((platform) => platform.id === platformId)?.name ??
  platformId;

export const formatMoney = (
  value: number,
  currency: string,
  locale: string,
): string =>
  // Colombian formatting ("$ 3.500.000") for the agency's Spanish locale.
  new Intl.NumberFormat(locale === "es" ? "es-CO" : locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(value);

// Date-only values ("2026-10-04") must be read as local dates: new Date() on
// that string means UTC midnight, which shows the previous day in Colombia.
export const formatDateOnly = (value: string, locale: string): string => {
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
